export default "__VITE_ASSET__cfab9d6b__"